module.exports = __webpack_public_path__ + "static/media/message.e8f7c656.svg";